module.exports = "<level-prologue ng-if=\"lpc.levelId=='prologue'\"></level-prologue> ";


//////////////////
// WEBPACK FOOTER
// ./components/pages/levelPage/levelPage.html
// module id = 51
// module chunks = 0